import { render } from "./insight.vue?vue&type=template&id=98388ef2"
import script from "./insight.vue?vue&type=script&lang=js"
export * from "./insight.vue?vue&type=script&lang=js"

import "./insight.vue?vue&type=style&index=0&id=98388ef2&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/search-result/template4/components/insight.vue'],['render',render],['__file',"insight.vue"]])

export default __exports__